import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import { PetszelPasswordResetComponent } from './petszel-password-reset/petszel-password-reset.component';
import { ConfirmResetComponent } from './confirm-reset/confirm-reset.component';
import { RouterModule } from '@angular/router';
import { ResetPasswordEmailComponent } from './reset-password-email/reset-password-email.component';
import { PetszelLoginComponent } from './petszel-login/petszel-login.component'; // Import the PetszelLoginComponent
import { NavigationComponent } from './navigation/navigation.component';
import { PetszelPoweredComponent } from './petszel-powered/petszel-powered.component';
import { PrimaryBtnComponent } from './primary-btn/primary-btn.component';
import { PetszelPoweredNobrandComponent } from './petszel-powered-nobrand/petszel-powered-nobrand.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { PetszelPartnerSummaryComponent } from '../../../petszel-staff/src/app/components/petszel-partner-summary/petszel-partner-summary.component';
import { LayoutModule } from '@angular/cdk/layout';
import { PlacesListComponent } from './places-list/places-list.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { LoadingComponent } from './loading/loading.component';
import { ToastsContainerComponent } from './toasts-container/toasts-container.component';
import { NgbNavModule, NgbToastModule } from "@ng-bootstrap/ng-bootstrap";
import { FooterNavComponent } from './footer-nav/footer-nav.component';
import { SortableHeaderDirective } from './directives/sortable-header.directive';
import { DocumentsLinksComponent } from './document-link/documents-links/documents-links.component';
import { DocumentsModalComponent } from './document-link/documents-modal/documents-modal.component';
import { FormatUrlPipe } from './document-link/documents-links/format-url.pipe';
import { EditDocLinksComponent } from './document-link/edit-doc-links/edit-doc-links.component';
import { DeleteDocLinksComponent } from './document-link/delete-doc-links/delete-doc-links.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OrganizationPartnersComponent } from './partners/organization-partners/organization-partners.component';
import { PartnerDeleteComponent } from './partners/partner-delete/partner-delete.component';
import { EditPartnerComponent } from './partners/edit-partner/edit-partner.component';
import { UnblockPartnerComponent } from './partners/unblock-partner/unblock-partner.component';
import { ProviderOffersComponent } from './provider-offers/provider-offers.component';
import { ProviderOffersOfferComponent } from './provider-offers/provider-offers-offer/provider-offers-offer.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { StateProvinceDropdownComponent } from './state-province-dropdown/state-province-dropdown.component';
import { DesignSystemLoginComponent } from './design-system/components/login/login.component';
import { DsColorbarComponent } from './design-system/components/colorbar/colorbar.component';
import { DsInfoBannerComponent } from './design-system/components/info-banner/info-banner.component';
import { DsNoticeComponent } from './design-system/components/notice/notice.component';
import { DsFormFieldComponent } from './design-system/components/form-field/form-field.component';
import { DsStateProvinceDropdownComponent } from './design-system/components/state-province-dropdown/state-province-dropdown.component';
import { NewLoadingComponent } from './new-loading/new-loading.component';
import { DesignSystemResetPasswordEmailComponent } from './design-system/components/reset-password-email/reset-password-email.component';
import { DsFormSelectComponent } from './design-system/components/form-select/form-select.component';

@NgModule({
  declarations: [
    PetszelPasswordResetComponent,
    ConfirmResetComponent,
    ResetPasswordEmailComponent,
    PetszelLoginComponent,
    NavigationComponent,
    PetszelPoweredComponent,
    PrimaryBtnComponent,
    PetszelPoweredNobrandComponent,
    PetszelPartnerSummaryComponent,
    PlacesListComponent,
    ErrorMessageComponent,
    LoadingComponent,
    ToastsContainerComponent,
    FooterNavComponent,
    SortableHeaderDirective,
    DocumentsLinksComponent,
    DocumentsModalComponent,
    FormatUrlPipe,
    EditDocLinksComponent,
    DeleteDocLinksComponent,
    OrganizationPartnersComponent,
    PartnerDeleteComponent,
    EditPartnerComponent,
    UnblockPartnerComponent,
    ProviderOffersComponent,
    ProviderOffersOfferComponent,
    ConfirmationModalComponent,
    StateProvinceDropdownComponent,
    DesignSystemLoginComponent,
    DsColorbarComponent,
    DsInfoBannerComponent,
    DsNoticeComponent,
    DsFormFieldComponent,
    DsStateProvinceDropdownComponent,
    DesignSystemResetPasswordEmailComponent,
    DsFormSelectComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    GoogleMapsModule,
    LayoutModule,
    FormsModule,
    MatDialogModule,
    NgbToastModule,
    DragDropModule,
    NgbNavModule,
    NewLoadingComponent
  ],
  exports: [
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    PetszelPasswordResetComponent,
    ConfirmResetComponent,
    DocumentsLinksComponent,
    ResetPasswordEmailComponent,
    PetszelLoginComponent,
    NavigationComponent,
    FooterNavComponent,
    PetszelPoweredComponent,
    PrimaryBtnComponent,
    PetszelPoweredNobrandComponent,
    GoogleMapsModule,
    PetszelPartnerSummaryComponent,
    PlacesListComponent,
    ErrorMessageComponent,
    LoadingComponent,
    ToastsContainerComponent,
    SortableHeaderDirective,
    FormatUrlPipe,
    OrganizationPartnersComponent,
    EditPartnerComponent,
    PartnerDeleteComponent,
    ProviderOffersComponent,
    ConfirmationModalComponent,
    StateProvinceDropdownComponent,
    DesignSystemLoginComponent,
    DsColorbarComponent,
    DsInfoBannerComponent,
    DsNoticeComponent,
    DsFormFieldComponent,
    DsStateProvinceDropdownComponent,
    NewLoadingComponent,
    DesignSystemResetPasswordEmailComponent,
    DsFormSelectComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PetszelSharedModule {}
